// src/analytics.js
import ReactGA from 'react-ga4';

export const initGA = () => {
  ReactGA.initialize('G-MVWRCQZZDH');
};

export const logPageView = () => {
  ReactGA.send({
    hitType: 'pageview',
    page_path: window.location.pathname,
    page_title: document.title,
  });
};